import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import Link from '@tiptap/extension-link';
import Mention from '@tiptap/extension-mention';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import { Color } from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import Superscript from '@tiptap/extension-superscript';
import Subscript from '@tiptap/extension-subscript';
import { ResizableImage } from './ResizableImage';
import { Table } from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import { CalloutBox, StyledText } from './calloutNode';
import { createMentionSuggestion } from './mentionSuggestion';

type Variable = { id: string; label: string };

interface BuildExtensionsOptions {
    placeholder: string;
    variables: Variable[];
}

export function buildExtensions({ placeholder, variables }: BuildExtensionsOptions) {
    return [
        StarterKit,
        CalloutBox,
        Underline,
        Superscript,
        Subscript,
        StyledText,
        Color,
        Highlight.configure({
            multicolor: true,
        }),
        TextAlign.configure({
            types: ['heading', 'paragraph'],
        }),
        Placeholder.configure({
            placeholder,
        }),
        Link.configure({
            openOnClick: false,
        }),
        ResizableImage,
        Table.configure({
            resizable: true,
        }),
        TableRow,
        TableHeader,
        TableCell,
        Mention.configure({
            HTMLAttributes: {
                class: 'mention',
            },
            suggestion: createMentionSuggestion(variables),
            // Resolve the display label live from the current variable list by
            // GUID, so renaming a variable is reflected everywhere it is used
            // (the durable reference is the data-id GUID, never the label).
            renderText: ({ node }) => {
                const match = variables.find((v) => v.id === node.attrs.id);
                return `@${match?.label ?? node.attrs.label ?? node.attrs.id}`;
            },
            renderHTML: ({ node }) => {
                const match = variables.find((v) => v.id === node.attrs.id);
                const label = match?.label ?? node.attrs.label ?? node.attrs.id;
                return [
                    'span',
                    { 'data-type': 'mention', 'data-id': node.attrs.id, 'data-label': label, class: 'mention' },
                    `@${label}`,
                ];
            },
        }),
    ];
}
